import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

export const GreenSwitch = styled(Switch)(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,

  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transition: '200ms',

    // OFF (unchecked) thumb
    '& .MuiSwitch-thumb': {
      width: 14,
      height: 14,
      backgroundColor: '#fff',
      boxShadow: theme.shadows[2],
      border: 'none',
    },

    // OFF track
    '& + .MuiSwitch-track': {
      border: 'none',
      backgroundColor: '#d32f2f !important', // OFF kırmızı
      opacity: 0.9,
      borderRadius: 999,
    },

    // ON
    '&.Mui-checked': {
      transform: 'translateX(16px)',

      '& + .MuiSwitch-track': {
        backgroundColor: '#2e7d32 !important', // ON yeşil
        opacity: 0.9,
      },
    },

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  '& .MuiSwitch-track': {
    // theme override'ını ezmek için burada da garanti
    border: 'none !important',
  },
}));
